"use client";

import { PurchaseHistory } from "@/app/ec/product/[basePath]/purchase-history";

import moment from "moment";

export interface LastPurchasedProps {
  date: string | null | undefined;
  mpId: number;
  /** Consumer's `.lastPurchased` module class — the card/tile layout slot. */
  slotClass: string;
  /** Consumer's `.hasContent` module class — appended when a date exists (bag icon). */
  hasContentClass: string;
  isTopsortClickable?: boolean;
}

/**
 * "Purchased on MM/DD/YYYY" line for product cards and tiles (RNG-1593) — the single shared
 * replacement for the identical copies that lived in search/products and products-tile.
 * Renders the layout slot even without a date so the card grid keeps its shape; with a date it
 * renders the self-fetching PurchaseHistory trigger (history loads only when the modal opens).
 * Style hooks come from the consumer's own SCSS module.
 */
export default function LastPurchased({
  date,
  mpId,
  slotClass,
  hasContentClass,
  isTopsortClickable = false,
}: LastPurchasedProps) {
  const parsedDate = date ? moment(date) : null;
  const lastPurchased = parsedDate?.isValid() ? parsedDate.format("MM/DD/YYYY") : "";

  if (!lastPurchased) return <div className={slotClass} />;

  return (
    <PurchaseHistory
      lastPurchaseDate={lastPurchased}
      mpId={mpId}
      useCompactDisplay
      labelClass={`${slotClass} ${hasContentClass}`}
      isTopsortClickable={isTopsortClickable}
    />
  );
}
